//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UserLoginsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8201";

    }

    getUserLoginActivity(userId: number, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfUserLoginActivityResponseModel> {
        let url_ = this.baseUrl + "/api/user-logins/activity/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLoginActivity(_response);
        });
    }

    protected processGetUserLoginActivity(response: AxiosResponse): Promise<ListResultOfUserLoginActivityResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfUserLoginActivityResponseModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfUserLoginActivityResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfUserLoginActivityResponseModel>(null as any);
    }

    logUserActivity(model: UserActivityPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-logins/activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogUserActivity(_response);
        });
    }

    protected processLogUserActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    logUserActivityVM(model: VMUserActivityPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-logins/activity-vm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogUserActivityVM(_response);
        });
    }

    protected processLogUserActivityVM(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLastUsersActivityByApplication(userId: string | null | undefined, cancelToken?: CancelToken): Promise<UserApplicationLastLoginResponseModel[]> {
        let url_ = this.baseUrl + "/api/user-logins/last-users-activity-by-application?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastUsersActivityByApplication(_response);
        });
    }

    protected processGetLastUsersActivityByApplication(response: AxiosResponse): Promise<UserApplicationLastLoginResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserApplicationLastLoginResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserApplicationLastLoginResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            if (Array.isArray(resultData500)) {
                result500 = [] as any;
                for (let item of resultData500)
                    result500!.push(ErrorResultModel.fromJS(item));
            }
            else {
                result500 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserApplicationLastLoginResponseModel[]>(null as any);
    }
}

export class SharepointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8201";

    }

    createSharepointFolders(model: CreateSharepointFolderPostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/sharepoint/create-folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSharepointFolders(_response);
        });
    }

    protected processCreateSharepointFolders(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ListResultOfUserLoginActivityResponseModel implements IListResultOfUserLoginActivityResponseModel {
    totalRecords?: number;
    items?: UserLoginActivityResponseModel[] | undefined;

    constructor(data?: IListResultOfUserLoginActivityResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginActivityResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultOfUserLoginActivityResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfUserLoginActivityResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultOfUserLoginActivityResponseModel {
    totalRecords?: number;
    items?: UserLoginActivityResponseModel[] | undefined;
}

export class UserLoginActivityResponseModel implements IUserLoginActivityResponseModel {
    userId?: string | undefined;
    loggedInAt?: Date;
    ip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    region?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    applicationName?: string | undefined;

    constructor(data?: IUserLoginActivityResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.loggedInAt = _data["loggedInAt"] ? new Date(_data["loggedInAt"].toString()) : <any>undefined;
            this.ip = _data["ip"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.region = _data["region"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.applicationName = _data["applicationName"];
        }
    }

    static fromJS(data: any): UserLoginActivityResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginActivityResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["loggedInAt"] = this.loggedInAt ? this.loggedInAt.toISOString() : <any>undefined;
        data["ip"] = this.ip;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["region"] = this.region;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["applicationName"] = this.applicationName;
        return data;
    }
}

export interface IUserLoginActivityResponseModel {
    userId?: string | undefined;
    loggedInAt?: Date;
    ip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    region?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    applicationName?: string | undefined;
}

export class ErrorResultModel implements IErrorResultModel {
    errors?: string[];
    validationErrors?: { [key: string]: string[]; };

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errors?: string[];
    validationErrors?: { [key: string]: string[]; };
}

export class UserActivityPostModel implements IUserActivityPostModel {
    activityType?: ActivityType;

    constructor(data?: IUserActivityPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityType = _data["activityType"];
        }
    }

    static fromJS(data: any): UserActivityPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType;
        return data;
    }
}

export interface IUserActivityPostModel {
    activityType?: ActivityType;
}

export enum ActivityType {
    ADLogin = 0,
    DashboardAccess = 1,
    VMDesktopAccess = 2,
    VMAppAccess = 3,
}

export class VMUserActivityPostModel implements IVMUserActivityPostModel {
    apiKey!: string;
    username!: string;

    constructor(data?: IVMUserActivityPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): VMUserActivityPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new VMUserActivityPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["username"] = this.username;
        return data;
    }
}

export interface IVMUserActivityPostModel {
    apiKey: string;
    username: string;
}

export class UserApplicationLastLoginResponseModel implements IUserApplicationLastLoginResponseModel {
    userId?: string | undefined;
    applicationName?: string | undefined;
    applicationId?: string | undefined;
    loggedInCount?: number | undefined;
    lastLoggedInAt?: Date | undefined;

    constructor(data?: IUserApplicationLastLoginResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.loggedInCount = _data["loggedInCount"];
            this.lastLoggedInAt = _data["lastLoggedInAt"] ? new Date(_data["lastLoggedInAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserApplicationLastLoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserApplicationLastLoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["loggedInCount"] = this.loggedInCount;
        data["lastLoggedInAt"] = this.lastLoggedInAt ? this.lastLoggedInAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserApplicationLastLoginResponseModel {
    userId?: string | undefined;
    applicationName?: string | undefined;
    applicationId?: string | undefined;
    loggedInCount?: number | undefined;
    lastLoggedInAt?: Date | undefined;
}

export class CreateSharepointFolderPostModel implements ICreateSharepointFolderPostModel {
    ticketId!: number;
    ticketName!: string;

    constructor(data?: ICreateSharepointFolderPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.ticketName = _data["ticketName"];
        }
    }

    static fromJS(data: any): CreateSharepointFolderPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSharepointFolderPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["ticketName"] = this.ticketName;
        return data;
    }
}

export interface ICreateSharepointFolderPostModel {
    ticketId: number;
    ticketName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}